import repository from '@/repositories/repository'
const resource = 'stocks'
export default {
  export () {
    return repository.get(`${resource}/export`)
  },
  import ({ data, columns, unique }) {
    return repository.post(`${resource}/import`, { data, columns, unique })
  },
  importExcel (data) {
    return repository.post(`${resource}/import/excel`, { data })
  },
  countExport () {
    return repository.get(`${resource}/export/count`)
  },
  storeList (store, params) {
    return repository.get(`${resource}/store/list/${store}`, { params })
  },
  storeCount (store, params) {
    return repository.get(`${resource}/store/count/${store}`, { params })
  },
  storeAll (store) {
    return repository.get(`${resource}/store/all/${store}`)
  },
  withSupplier () {
    return repository.get(`${resource}/with-supplier`)
  },
}
